import { render, staticRenderFns } from "./InputTramite.vue?vue&type=template&id=f20c6904&"
import script from "./InputTramite.vue?vue&type=script&lang=js&"
export * from "./InputTramite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports